import React from "react";
import CustomFileDropper from "../dropers/CustomFileDropper";
import Button from "../button/Button";
import CancelButton from "../button/CancelButton";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

function MerchandiseCategoryForm({
  setFormData,
  formData,
  setLoading,
  loading,
  setError,
  isEditing,
  editMerchandiseCategory,
  createMerchandiseCategory,
  setIsModalOpen,
  fetchCategories,
  setIsEditing,
  error,
  pageLimit,
  pageNumber,
}) {
  const dispatch = useDispatch();
  const handleReset = () => {
    setFormData({ id: "", name: "", file: null });
    setIsEditing(false);
    setError(null);
    setIsModalOpen(false);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileDrop = (fileUrl) => {
    // Update formData with the uploaded file URL
    setFormData((prev) => ({ ...prev, file: fileUrl }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const payload = { name: formData.name, image: formData.file || "" };

      if (isEditing) {
        await dispatch(
          editMerchandiseCategory({ ...payload, id: formData.id })
        );
      } else {
        await dispatch(createMerchandiseCategory(payload));
      }

      setFormData({ id: "", name: "", file: null });
      setIsEditing(false);
      setIsModalOpen(false);
      fetchCategories({
        page: pageNumber,
        limit: pageLimit,
      });
    } catch (err) {
      setError(err.response.data.message);
      toast.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="mb-8">
      <div className="mb-4">
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-700"
        >
          Category Name
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
          className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="mb-4">
        <label
          htmlFor="file"
          className="block text-sm font-medium text-gray-700"
        >
          Upload Image
        </label>
        <CustomFileDropper
          title="Drop your image here"
          instructions="Supports PNG, JPG, JPEG, GIF (Max 1 file)"
          onFileDrop={handleFileDrop}
          type="image"
          fileTypes={["image/png", "image/jpeg", "image/jpg", "image/jfif"]}
          defaultFile={formData.file} // Pass the existing image URL for editing
          maxFiles={1}
        />
      </div>
      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
      <div className="flex gap-2">
        <Button
          type="submit"
          disabled={loading}
          text={loading ? "Saving..." : isEditing ? "Update" : "Create"}
        />
        <CancelButton type="button" onClick={handleReset} text={"Cancel"} />
      </div>
    </form>
  );
}

export default MerchandiseCategoryForm;
